import { IPromise, IQService } from 'angular';
import SecuredStorage from './secured-storage.service';

/* @ngInject */
export default class UserStorage {
  constructor(private securedStorage: SecuredStorage, private $q: IQService) {}

  public get(prefixKey: string): IPromise<any> {
    return this.getUserKey(prefixKey).then(userKey => {
      return this.securedStorage.get(userKey);
    });
  }

  public set(prefixKey: string, data) {
    return this.getUserKey(prefixKey).then(userKey => {
      this.securedStorage.set(userKey, data);
    });
  }

  public remove(prefixKey: string) {
    return this.getUserKey(prefixKey).then(userKey => {
      this.securedStorage.remove(userKey);
    });
  }

  private getUserKey(prefixKey: string): IPromise<string> {
    return this.$q.resolve('some-user'); // TODO: Implement.
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/local-storage/user-storage.service.ts